import StepRoute from '../classes/step-route.class';
import RouteNames from '../constants/route-names';
import NavigationGuards from '../utilities/navigation-guards';

const route = new StepRoute(
  RouteNames.AppointmentConfirmation,
  'confirmation/:appointmentId',
  () => import('@/views/steps/ConfirmationStep.vue'),
);

route.navigationGuard((to, from, next) => {
  const unauthenticatedPath = NavigationGuards.getUnauthenticatedPath(to);
  if (unauthenticatedPath) {
    window.location.href = unauthenticatedPath;
    next(false);
  } else {
    next();
  }
});

export default route.getRoute();
